export const MAX_BOUNDS = [
    [-180, -60], // Southwest coordinates - full longitude, adjusted southern coverage
    [180, 85], // Northeast coordinates - full longitude, extended northern coverage
];

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 8;
export const LONGITUDE_FLIP = 50;

export const DEFAULT_MAP_STATE = {
    maxZoom: MAX_ZOOM,
    minZoom: MIN_ZOOM,
    zoom: 0, // Will be overridden by fitBounds
    longitude: 0,
    latitude: 20, // Shift center slightly north to show more top areas
};

export const mapBgColours = {
    'rank_type_1': '#405363',
    'rank_type_2': '#536472',
    'rank_type_3': '#667582',
    'rank_type_4': '#798691',
    'rank_type_5': '#8C98A1',
    'rank_type_6': '#9FA9B1',
    'rank_type_7': '#B3BAC1',
    'rank_type_8': '#C5CBD0',
    'rank_type_9': '#D9DDE0',
    'rank_type_10': '#ECEDEF',
    'visa_free_access': '#39AC4A',
    'visa_on_arrival': '#53C14A',
    'electronic_travel_authorisation':'#83D87A',
    'visa_online':'#F66662',
    'visa_required':'#CB172B'
}

